<div class="modal-column" *ngIf="auth.isAuthenticated() && auth.userInfo">
  <div class="signup-left-content">
    <h3 class="join-edg-heading">Please confirm your email to complete the registration</h3>
    <div class="signup-image"></div>
    <div class="licence-wrap">
      <img src="/assets/images/v2/register/logos/curacao-logo.png"
           alt="" class="curacao-licence _10-spacer">
      <span class="casino-text">First licenced crypto casino in the world.</span>
    </div>

    <div class="signup-value-wrap">
      <div class="_20-px-spacer"></div>
      <img src="/assets/images/v2/register/logos/mastercard.svg" height="25" class="onboarding-icon">
      <img src="/assets/images/v2/register/logos/visa.svg" width="40" class="onboarding-icon">
      <img src="/assets/images/v2/register/logos/indacoin.svg" width="30" class="onboarding-icon">
      <img src="/assets/images/v2/register/logos/bitcoin.svg" width="50" class="onboarding-icon">
      <img src="/assets/images/v2/register/logos/changelly.svg" width="70" class="onboarding-icon">
      <img src="/assets/images/v2/register/logos/edgeless.svg" width="60" class="onboarding-icon">
      <img src="/assets/images/v2/register/logos/ethereum.svg" width="60" class="onboarding-icon">
    </div>
  </div>
  <div class="form-wrap">
    <p class="subtext">Confirmation e-mail was sent to:
      <a href="#" (click)="resendCode($event)">{{ auth.userInfo.email }}</a>
    </p>
    <form (ngSubmit)="submit()" [formGroup]="form" novalidate>
      <p class="small-text">Enter verification code</p>
      <div class="confirmation-code-wrap">
        <app-form-input formControlName="code_1" type="number" [show-icons]="false" class="width-auto" #code1
                        (ngModelChange)="codeChange($event, code2)" data-id="signup2-code1-input"></app-form-input>
        <app-form-input formControlName="code_2" type="number"  [show-icons]="false" class="width-auto" #code2
                        (ngModelChange)="codeChange($event, code3)" data-id="signup2-code2-input"></app-form-input>
        <app-form-input formControlName="code_3" type="number" [show-icons]="false" class="width-auto" #code3
                        (ngModelChange)="codeChange($event, code4)" data-id="signup2-code3-input"></app-form-input>
        <p>-</p>
        <app-form-input formControlName="code_4" type="number" [show-icons]="false" class="width-auto" #code4
                        (ngModelChange)="codeChange($event, code5)" data-id="signup2-code4-input"></app-form-input>
        <app-form-input formControlName="code_5" type="number" [show-icons]="false" class="width-auto" #code5
                        (ngModelChange)="codeChange($event, code6)" data-id="signup2-code5-input"></app-form-input>
        <app-form-input formControlName="code_6" type="number" [show-icons]="false" class="width-auto" #code6
                        (ngModelChange)="codeChange($event)" data-id="signup6-code1-input"></app-form-input>
      </div>
      <div class="resend-confirmation-code">
        Didn't get the code?
        <a href="/home" class="resend-code" (click)="resendCode($event)" data-id="signup2-resend-href">Resend Code</a>
      </div>
      <app-form-button type="submit" class="primary full-width" [disabled]="loading || form.invalid"
                       data-id="signup2-submit-buttton">
        Verify email
      </app-form-button>
    </form>
  </div>
  <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup" data-id="signup2-close-href">
    <i class="fal fa-times"></i>
  </a>
  <div [innerHtml]="pixel"></div>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/signup/2/signup-modal.template.html